"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IconWrapper", {
  enumerable: true,
  get: function get() {
    return _IconWrapper.default;
  }
});
Object.defineProperty(exports, "ProgressDots", {
  enumerable: true,
  get: function get() {
    return _Dots.default;
  }
});
exports.default = void 0;

var _CmeterUI = _interopRequireDefault(require("./CmeterUI"));

var _IconWrapper = _interopRequireDefault(require("./components/IconWrapper"));

var _Dots = _interopRequireDefault(require("./components/Dots"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  const styles = ".cmeter,\n.cmeter__stage {\n  display: flex; }\n\n.cmeter__iconWrapper,\n.cmeter__dots {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  box-sizing: border-box;\n  position: relative;\n  transition: 0.4s ease-in fill, 0.3s ease-in opacity; }\n\n.cmeter__iconWrapper {\n  width: 100px;\n  height: 100px;\n  margin: 0 10px;\n  border-radius: 50%;\n  padding: 5px;\n  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);\n  overflow: hidden; }\n  .cmeter__iconWrapper svg {\n    transform: scale(0.7);\n    transition: transform 0.2s ease-in; }\n\n.cmeter__dots {\n  width: 100px;\n  margin: 0 10px; }\n\n.cmeter--sleep .cmeter__iconWrapper {\n  opacity: 0.5;\n  fill: grey; }\n\n.cmeter--queued .cmeter__iconWrapper {\n  opacity: 1;\n  fill: gray; }\n\n.cmeter--testing {\n  fill: #00aeff; }\n  .cmeter--testing .cmeter__iconWrapper svg {\n    transform: scale(0.88); }\n\n.cmeter--tested {\n  fill: #88ff00; }\n\n.cmeter--failed {\n  fill: #ff0037; }\n  .cmeter--failed .cmeter__iconWrapper svg {\n    transform: scale(0.88); }\n\n.cmeter--testing .circle-move-up-down {\n  animation: circle-move-up-down 1s infinite linear; }\n\n.cmeter--testing .circle-mid-move-up-down {\n  animation: circle-mid-move-up-down 1s infinite linear; }\n\n@keyframes circle-move-up-down {\n  25% {\n    transform: scale(1, 1.1); }\n  75% {\n    transform: scale(1, 0.9); } }\n\n@keyframes circle-mid-move-up-down {\n  25% {\n    transform: scale(1, 0.9); }\n  75% {\n    transform: scale(1, 1.1); } }\n";
  const fileName = "index_style";
  const element = document.querySelector("style[data-sass-component='index_style']");

  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var _default = _CmeterUI.default;
exports.default = _default;